import React from 'react';
import PropTypes from 'prop-types';

import SimpleCheckbox from '../../../../common/simpleCheckbox';
import { permissionPropType } from './permissionsData';

const PermissionCheckbox = ({ permissionData, showColumn, onChange, disabled }) => (
  <div className="u-inline-block c-info-tooltip-new-handler">
    <React.Fragment display-if={showColumn && !!permissionData}>
      <SimpleCheckbox
        name={permissionData.fieldName}
        id={permissionData.fieldName.replace('.', '_')}
        containerClass="c-checkbox--small u-mr0"
        onChange={onChange}
        disabled={disabled}
      />
      <div
        className="c-info-tooltip-new__content"
        display-if={!!permissionData.tooltip}
      >
        {permissionData.tooltip}
      </div>
    </React.Fragment>
  </div>
);

PermissionCheckbox.propTypes = {
  permissionData: permissionPropType,
  showColumn: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

PermissionCheckbox.defaultProps = {
  permissionData: null,
};

export default PermissionCheckbox;
